// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__1FfrE","row":"styles_row__3aFMe"};